// @flow
import React from 'react';
import ONELogo from 'assets/client/one-logo.png';
import css from './OneLogo.scss';

export function OneLogo() {
	return (
		<div className={css.oneLogo}>
			<img src={ONELogo} alt="ONE Logo" />
		</div>
	);
}

OneLogo.defaultProps = {
	className: '',
};
